import { render, staticRenderFns } from "./ContadorBureau.vue?vue&type=template&id=46dff82b&scoped=true"
import script from "./ContadorBureau.vue?vue&type=script&lang=js"
export * from "./ContadorBureau.vue?vue&type=script&lang=js"
import style0 from "./ContadorBureau.vue?vue&type=style&index=0&id=46dff82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dff82b",
  null
  
)

export default component.exports